import { render, staticRenderFns } from "./AppFooterComponent.vue?vue&type=template&id=b014a27c&scoped=true&"
import script from "./AppFooterComponent.vue?vue&type=script&lang=ts&"
export * from "./AppFooterComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b014a27c",
  null
  
)

export default component.exports